import React, { useState, FC } from 'react';
import cn from 'classnames';

import { ReactComponent as SearchIcon } from '@assets/search.svg';
import { ReactComponent as ClearIcon } from '@assets/close.svg';
import st from './Search.module.css';

type SearchProps = {
  value: string;
  onChange: (event: any) => void;
  isSeparated?: boolean;
};

const Search: FC<SearchProps> = ({ isSeparated = false, onChange, value }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div className={cn(st.wrapper, { [st.separated]: isSeparated })}>
      <label className={cn(st.search, { [st.searchFocused]: focused })}>
        <SearchIcon className={st.searchIcon} />
        <input
          value={value}
          type="text"
          aria-label="Найти услугу"
          className={st.searchInput}
          placeholder="Найти услугу"
          onChange={(event) => onChange(event.target.value)}
          onBlur={() => setFocused(false)}
          onFocus={() => setFocused(true)}
          data-testid="catalogSearchInput"
        />
        {value.length !== 0 && (
          <button
            data-testid="catalogSearchInputClear"
            type="button"
            className={st.searchClear}
            aria-label="Очистить поле"
            onClick={() => onChange('')}
          >
            <ClearIcon />
          </button>
        )}
      </label>
    </div>
  );
};

export default Search;
